import { api_url } from "../../utils/constants";
const axios = require('axios').default;

// The login token when there is one (never during server-side rendering). Public profile
// reads send it so the owner also gets their private albums and posts; the backend takes
// "who is looking" from the token, not from the user id in the request.
const optionalAuthHeader = () => {
    const jwtToken = typeof window !== 'undefined' ? window.localStorage.getItem('jwtToken') : null
    return jwtToken ? { 'Authorization': 'Bearer ' + jwtToken } : {}
}

export const downloadBuzz = (userId, userCountry, incrementSize, lowerLimit) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('userId', userId);
        fdd.append('userCountry', userCountry);
        fdd.append('upperLimit', incrementSize);
        fdd.append('lowerLimit', lowerLimit);

        axios({
          method : "POST",
          url :  api_url + "/DownloadNews",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const downloadMyBuzz = (userId, stringUserId, incrementSize, lowerLimit) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/profile/DownloadMyPosts",
          params : {'userId': userId, 'stringUserId': stringUserId, 'upperLimit': incrementSize, 'lowerLimit': lowerLimit },
          headers:  { "Content-Type": "application.json", ...optionalAuthHeader() },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const uploadPost = (userId, userFullNm, file, fileType, albumName, desc, postSecurity) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('userId', userId);
        fdd.append('userFullNm', userFullNm);
        fdd.append('file', file);
        fdd.append('albumName', albumName);
        fdd.append('desc', desc);
        fdd.append('postSecurity', postSecurity);
        fdd.append('fileType', fileType);

        axios({
          method : "POST",
          url :  api_url + "/UploadPost",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const uploadAction = (buzz, userId, userFullName, actionTyp, content) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('entityId', buzz.entityId);
        fdd.append('entityTyp', buzz.entityTyp);
        fdd.append('userId', buzz.userId);
        fdd.append('actUserId', userId);
        fdd.append('actUserNm', userFullName);
        fdd.append('actionTyp', actionTyp);
        fdd.append('content', content);

        axios({
          method : "POST",
          url :  api_url + "/UploadAction",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const removePost = (entityId, userId) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('entityId', entityId)
        fdd.append('userId', userId)

        axios({
          method : "POST",
          url :  api_url + "/RemovePost",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const editPostPrivacy = (entityId, userId, postSecurity) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('entityId', entityId)
        fdd.append('userId', userId)
        fdd.append('postSecurity', postSecurity)

        axios({
          method : "POST",
          url :  api_url + "/EditBuzzPrivacy",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const removeAction = (entityIdInt) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('entityIdInt', entityIdInt)

        axios({
          method : "POST",
          url :  api_url + "/RemoveAction",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const removeLikeAction = (entityId, userId, actionTyp) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('entityId', entityId)
        fdd.append('userId', userId)
        fdd.append('actionTyp', actionTyp)

        axios({
          method : "POST",
          url :  api_url + "/RemoveLikeAction",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const downloadBuzzByEnityId = (entityId, userId) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/public/DownloadBuzzByEntityId",
          params : {'entityId': entityId, 'userId': userId},
          headers:  { "Content-Type": "application/json",},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const downloadBuzzActions = (entityId) => {
    return new Promise((resolve, reject) => {
        axios({
          method : "GET",
          url :  api_url + "/public/DownloadNewsAction",
          params : {'entityId': entityId},
          headers:  { "Content-Type": "application/json", },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const getAlbumPrivacy = ( albumUserId, albumName ) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('albumUserId', albumUserId)
        fdd.append('albumName', albumName)

        axios({
          method : "POST",
          url :  api_url + "/GetAlbumPrivacy",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const deleteAlbum = ( userId, albumName ) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('userId', userId)
        fdd.append('albumName', albumName)

        axios({
          method : "POST",
          url :  api_url + "/DeleteAlbum",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const updateAlbumPrivacy = (  albumName, albumPrivacy, albumUserId ) => {
    return new Promise((resolve, reject) => {
        let jwtToken = window.localStorage.getItem('jwtToken');

        let fdd = new FormData();
        fdd.append('albumName', albumName)
        fdd.append('albumPrivacy', albumPrivacy)
        fdd.append('albumUserId', albumUserId)

        axios({
          method : "POST",
          url :  api_url + "/UpdateAlbumPrivacy",
          data : fdd,
          headers:  { "Content-Type": "multipart/form-data", 'Authorization': 'Bearer ' + jwtToken },
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}
